import { render, staticRenderFns } from "./SetupCard.vue?vue&type=template&id=6950006f&"
import script from "./SetupCard.vue?vue&type=script&lang=js&"
export * from "./SetupCard.vue?vue&type=script&lang=js&"
import style0 from "./SetupCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports